import { Box } from "@mui/material";
import { ReactNode } from "react";
import { FormExtraction } from "../../../../interface/returns";
import FormHeader from "./FormHeader";
import FormConfidenceIndicator from "./FormConfidenceIndicator";

interface FormContainerProps<T> {
    formName: string;
    formData: FormExtraction<T>;
    currentExtraction: any;
    formPageNumber: number;
    totalPages?: number;
    children: ReactNode;
    showConfidence?: boolean;
}

const FormContainer = <T,>({
    formName,
    formData,
    currentExtraction,
    formPageNumber,
    totalPages,
    children,
    showConfidence = true,
}: FormContainerProps<T>) => (
    <Box>
        <FormHeader
            formName={formName}
            formData={formData}
            currentExtraction={currentExtraction}
            formPageNumber={formPageNumber}
            totalPages={totalPages}
        />

        {/* Form content */}
        {children}

        {/* Confidence scores */}
        {showConfidence && <FormConfidenceIndicator fieldConfidence={currentExtraction?.fieldConfidence} />}
    </Box>
);

export default FormContainer;
